import { Navigate } from "react-router-dom";

/**
 * Componente que redirige a la sección inicial del admin según el rol.
 * Para el rol Ne6pwRmFkr4bArJN47NZ redirige a companies, otros a units.
 */
export default function AdminIndexRedirect() {
  const userRole = localStorage.getItem("userRole");

  if (userRole === "admin reseller") {
    return <Navigate to="/admin/companies" replace />;
  }

  return <Navigate to="/admin/units" replace />;
}
